import { useMutation } from '@tanstack/react-query'
import { FrontendEventRequest } from '@chilipiper/api-client/src/chat-platform-chat'
import { useApiClient } from '@chilipiper/api-client/src/context'

export const useCollectEvent = (tenantId: string, guestId: string) => {
  const { chatPlatformChat } = useApiClient()

  return useMutation({
    mutationFn: (event: FrontendEventRequest) =>
      chatPlatformChat.postApiV1PublicTenantTenantidReportingCollect(tenantId, { guestId }, event),
  })
}
